import React from 'react';
import Validator from 'validatorjs';
import { Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import DecimalAmount from '../../../../support/DecimalAmount';
import MonedaPOptions from '../../support/catalogs/complementos/pagos/MonedaPOptions';
import FactorajeFinancieroCalculator from '../../support/factoraje/FactorajeFinancieroCalculator';

const FactorajeForm = (props) => {
  const { data, input = {} } = props;

  const { FactorajeFinanciero = {} } = input?.Factoraje ?? {};
  const { MontoContrato, Equivalencia, ImportePagoInicial, CompensacionHonorarios, Honorarios, Moneda, Aforo } =
    FactorajeFinanciero ?? {};

  const getRules = (data) => {
    return {
      Moneda: ['required', 'string'],
      Aforo: ['required', 'decimal:2', 'min:0.01'],
      Honorarios: ['required', 'decimal:2', 'min:0.01'],
      Equivalencia: ['required', 'decimal:2', 'min:0.01'],
      MontoContrato: ['required', 'decimal:2', 'min:0.01'],
      ImportePagoInicial: ['required', 'decimal:2', 'min:0.01'],
      CompensacionHonorarios: ['required', 'decimal:2', 'min:0.01'],
      TasaInteres: ['required', 'decimal:2', 'min:0.01'],
      MontoAforo: ['required', 'decimal:2', 'min:0.01'],
      ImporteAforado: ['required', 'decimal:2', 'min:0.01'],
      CompensacionIntereses: ['required', 'decimal:2', 'min:0.01'],
      ImportePagoFinal: ['required', 'decimal:2', 'min:0.01'],
    };
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    return validator;
  };

  const handleOnChange = (value) => {
    if (!MontoContrato && value.Equivalencia) {
      value.MontoContrato = DecimalAmount.make(input?.Total * value.Equivalencia).toFixed(2);
    }

    let newData = {
      ...data,
      ...value,
    };

    newData = FactorajeFinancieroCalculator.make(newData).apply();

    const validator = validate(newData);

    props.onChange({
      ...newData,
      ...value,
      isValid: validator.passes(),
    });
  };

  const rules = getRules(data);

  return (
    <Form
      autoComplete="off"
      className="mt-2"
    >
      <div className="py-3 text-upper">
        <strong>Factoraje Financiero</strong>
      </div>

      <Row>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Monto Contrato"
            name="MontoContrato"
            placeholder=""
            help=""
            disabled={!!MontoContrato}
            rules={rules.MontoContrato}
            value={data.MontoContrato}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="select"
            label="Moneda"
            name="Moneda"
            placeholder=""
            help=""
            disabled={!!Moneda}
            rules={rules.Moneda}
            value={data.Moneda}
            options={MonedaOptions}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Equivalencia"
            name="Equivalencia"
            placeholder=""
            help=""
            disabled={!!Equivalencia}
            rules={rules.Equivalencia}
            value={data.Equivalencia}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Aforo"
            name="Aforo"
            placeholder=""
            help="Porcentaje %"
            disabled={!!Aforo}
            rules={rules.Aforo}
            value={data.Aforo}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Honorarios"
            name="Honorarios"
            placeholder=""
            help="Porcentaje %"
            disabled={!!Honorarios}
            rules={rules.Honorarios}
            value={data.Honorarios}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Tasa Interes"
            name="TasaInteres"
            placeholder=""
            help="Porcentaje %"
            rules={rules.TasaInteres}
            value={data.TasaInteres}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <div className="py-2">
        <strong className="text-muted">Aforo</strong>
      </div>

      <Row>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Monto Aforo"
            name="MontoAforo"
            placeholder=""
            help=""
            rules={rules.MontoAforo}
            value={data.MontoAforo}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Importe Aforado"
            name="ImporteAforado"
            placeholder=""
            help=""
            rules={rules.ImporteAforado}
            value={data.ImporteAforado}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <div className="py-3">
        <strong className="text-muted">Totales</strong>
      </div>
      <Row>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Importe Pago Inicial"
            name="ImportePagoInicial"
            placeholder=""
            help=""
            disabled={!!ImportePagoInicial}
            rules={rules.ImportePagoInicial}
            value={data.ImportePagoInicial}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Compensacion Honorarios"
            name="CompensacionHonorarios"
            placeholder=""
            help=""
            disabled={!!CompensacionHonorarios}
            rules={rules.CompensacionHonorarios}
            value={data.CompensacionHonorarios}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Importe Pago Final"
            name="ImportePagoFinal"
            placeholder=""
            help=""
            rules={rules.ImportePagoFinal}
            value={data.ImportePagoFinal}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Compensacion Intereses"
            name="CompensacionIntereses"
            placeholder=""
            help=""
            rules={rules.CompensacionIntereses}
            value={data.CompensacionIntereses}
            onChange={handleOnChange}
          />
        </Col>
      </Row>
    </Form>
  );
};

const MonedaOptions = MonedaPOptions.filter((moneda) => {
  if (['', 'MXN', 'USD'].includes(moneda.value)) {
    return moneda;
  }

  return null;
});

export default FactorajeForm;
